import { render, staticRenderFns } from "./the-notification.vue?vue&type=template&id=3b577799&scoped=true"
var script = {}
import style0 from "./the-notification.vue?vue&type=style&index=0&id=3b577799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b577799",
  null
  
)

export default component.exports